import { Modal } from "@/shared/components/Modal";
import { Button } from "@/shared/components/form/Button";
import { AlertTriangle } from "lucide-react";
import useTranslations from "@/shared/lang/useTranslations";

interface DeleteOrganizationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  organizationName?: string;
  isLoading?: boolean;
}

export const DeleteOrganizationModal = ({
  isOpen,
  onClose,
  onConfirm,
  organizationName,
  isLoading = false,
}: DeleteOrganizationModalProps) => {
  const { t } = useTranslations("cards");

  const confirmationMessage = organizationName
    ? t("delete_organization_modal_confirmation_message", {
        organizationName: `"${organizationName}"`,
      })
    : t("delete_organization_modal_confirmation_message", {
        organizationName: "",
      });

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t("delete_organization_modal_title")}
      size="md"
      footer={
        <>
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            {t("delete_organization_modal_button_cancel")}
          </Button>
          <Button
            variant="danger"
            onClick={onConfirm}
            isLoading={isLoading}
            disabled={isLoading}
            className="bg-red-400 hover:bg-red-500 active:bg-red-600 focus:ring-red-400 disabled:bg-red-300 dark:bg-red-500 dark:hover:bg-red-400 dark:active:bg-red-500 dark:disabled:bg-red-600"
          >
            {t("delete_organization_modal_button_delete")}
          </Button>
        </>
      }
    >
      <div className="space-y-4">
        <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 flex items-start gap-3">
          <AlertTriangle className="h-5 w-5 text-red-600 dark:text-red-500 shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-red-800 dark:text-red-200">
              {t("delete_organization_modal_warning")}
            </p>
          </div>
        </div>

        <p className="text-sm text-gray-600 dark:text-gray-400">
          {confirmationMessage}
        </p>
      </div>
    </Modal>
  );
};
